import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { getIsLogged, getIsPrime, isLoading } from './login.utils';

const LoginProviderContext = createContext(null);

export const LoginProvider = ({ loginProps, children }) => {
  const { user } = loginProps;
  const isPrime = getIsPrime(user);

  const values = useMemo(() => {
    return {
      user,
      isLogged: getIsLogged(user),
      isLoading: isLoading(user),
      isPrime,
    };
  }, [user, isPrime]);

  return (
    <LoginProviderContext.Provider value={values}>
      {children}
    </LoginProviderContext.Provider>
  );
};

LoginProvider.propTypes = {
  loginProps: PropTypes.shape({
    user: PropTypes.object.isRequired,
  }),
};

export const LoginFunnelProvider = ({ loginProps, children }) => {
  const { user } = loginProps;
  const isPrime = getIsPrime(user);

  const values = useMemo(() => {
    return {
      user,
      isLogged: getIsLogged(user),
      isLoading: isLoading(user),
      isPrime,
      isPrimeLogged: getIsLogged(user) && isPrime,
    };
  }, [user, isPrime]);

  return (
    <LoginProviderContext.Provider value={values}>
      {children}
    </LoginProviderContext.Provider>
  );
};

LoginProvider.propTypes = {
  loginProps: PropTypes.shape({
    user: PropTypes.object.isRequired,
  }),
};

export const useLogin = () => {
  const context = useContext(LoginProviderContext);
  if (!context) {
    throw new Error('must be used within a LoginProvider');
  }

  return context;
};
